module.exports = __webpack_public_path__ + "static/media/Person9.b1f1e5c3.png";